import { jsx as _jsx } from "react/jsx-runtime";
import { CUITag, CUITagLabel } from 'connect-dot-com-ui-components/Components/CUITag/CUITag';
import FormattedMessage from 'I18n/components/FormattedMessage';

const HomepageComingSoonTag = (_ref) => {
  let rest = Object.assign({}, _ref);
  return /*#__PURE__*/_jsx(CUITag, Object.assign({
    color: "GREYSCALE.MOON",
    backgroundColor: "GREYSCALE.GALAXY"
  }, rest, {
    children: /*#__PURE__*/_jsx(CUITagLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.homepage.cards.comingSoonTag"
      })
    })
  }));
};

export default HomepageComingSoonTag;